import React, { useState } from 'react';
import { Box, Typography, Paper, Button, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { SwapHoriz, Pix, AccountBalance, CompareArrows } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TransferNewPage: React.FC = () => {
  const navigate = useNavigate();

  const transferTypes = [
    {
      title: 'PIX',
      description: 'Transferência instantânea 24h',
      icon: <Pix sx={{ fontSize: 48 }} />,
      path: '/pix/transfer',
      color: '#00A86B',
    },
    {
      title: 'TED',
      description: 'Transferência para outros bancos',
      icon: <AccountBalance sx={{ fontSize: 48 }} />,
      path: '/transfers/ted',
      color: '#1976d2',
    },
    {
      title: 'Entre Contas',
      description: 'Transferência entre contas Sicoob',
      icon: <CompareArrows sx={{ fontSize: 48 }} />,
      path: '/transfers/internal',
      color: '#7B1FA2',
    },
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <SwapHoriz sx={{ mr: 1, verticalAlign: 'middle' }} />
        Nova Transferência
      </Typography>

      <Typography color="text.secondary" sx={{ mb: 3 }}>
        Selecione o tipo de transferência que deseja realizar:
      </Typography>

      <Grid container spacing={3}>
        {transferTypes.map((type, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={{ height: '100%' }}>
              <CardActionArea onClick={() => navigate(type.path)} sx={{ height: '100%' }}>
                <CardContent sx={{ textAlign: 'center', py: 4 }}>
                  <Box sx={{ color: type.color, mb: 2 }}>
                    {type.icon}
                  </Box>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {type.title}
                  </Typography>
                  <Typography color="text.secondary" variant="body2">
                    {type.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TransferNewPage;
